import { render, staticRenderFns } from "./PluginFileOperator.vue?vue&type=template&id=c012604a&scoped=true"
import script from "./PluginFileOperator.vue?vue&type=script&lang=js"
export * from "./PluginFileOperator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c012604a",
  null
  
)

export default component.exports